// Theme tokens are CSS custom properties so a single `data-theme` attribute
// swap (see ThemeContext + the :root/[data-theme="light"] rules in Home.jsx)
// re-themes every component that imports T — no per-component changes needed.
export const T = {
  ink: "var(--ink)",
  inkSoft: "var(--ink-soft)",
  muted: "var(--muted)",
  faint: "var(--faint)",
  border: "var(--border)",
  surface: "var(--surface)",
  paper: "var(--paper)",
  white: "var(--white)",
  gold: "var(--gold)",
  goldLight: "var(--gold-light)",
  goldHover: "var(--gold-hover)",
  shadowSoft: "var(--shadow-soft)",
  shadowMedium: "var(--shadow-medium)",
};
